// extracted by mini-css-extract-plugin
module.exports = {"footer":"Search_footer__mZ5VJ","badge":"Search_badge__g4IaJ","course":"Search_course__fSBIv","topBar":"Search_topBar__R3D__"};